import Clickable from 'components/Common/Clickable'
import LineInfoCircleIcon from 'components/Luxkit/Icons/line/LineInfoCircleIcon'
import StatusLabel from 'components/Luxkit/Label/StatusLabel'
import React, { MouseEventHandler, useCallback } from 'react'

interface Props {
  /**
   * The percentage the budget is exceeded by.
   */
  underPercentage: number
  onClick: MouseEventHandler<HTMLButtonElement>
}

function PriceRowBusinessTravellerUnderBudget(props: Props) {
  const {
    underPercentage,
    onClick,
  } = props

  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()

    onClick(event)
  }, [onClick])

  return <Clickable onClick={handleClick}>
    <StatusLabel variant="confirmation" endIcon={!!onClick && <LineInfoCircleIcon />}>
      Under budget by {underPercentage}%
    </StatusLabel>
  </Clickable>
}

export default PriceRowBusinessTravellerUnderBudget
